import { render } from "./SecondBodyTemplate.vue?vue&type=template&id=62335758&scoped=true"
import script from "./SecondBodyTemplate.vue?vue&type=script&lang=js"
export * from "./SecondBodyTemplate.vue?vue&type=script&lang=js"

import "./SecondBodyTemplate.vue?vue&type=style&index=0&id=62335758&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62335758"]])

export default __exports__